import { Controller } from "@hotwired/stimulus"

export default class ModalMessageController extends Controller {
  static targets = ["title", "recipient"]

  populate({ detail: { relatedTarget } }) {
    const recipient = relatedTarget?.dataset.coreuiWhatever || ""
    this.titleTarget.textContent = recipient ? `New message to ${recipient}` : "New message"
    this.recipientTarget.value = recipient
  }
}
